export default {
  makeToast(options) {
    const opts = options || {};
    // reset everything to preserve defaults behavior
    $.toast().reset('all');

    const defaults = {
      text: 'Smart Template saved successfully!',
      heading: 'Success',
      icon: 'success',
      showHideTransition: 'fade',
      allowToastClose: true,
      hideAfter: 3000,
      stack: 5,
      position: 'top-right',
      textAlign: 'left',
      loader: true,
      loaderBg: '#9EC600',
    };

    $.toast({ ...defaults, ...opts });
  },
};
